module.exports = __webpack_public_path__ + "media/images/shared/icon_area_white-a6e59c9e3b39940345a7bb41b861a7e1.png";